// extracted by mini-css-extract-plugin
export var container = "_th-0";
export var table = "_th-2";
export var tableWrapper = "_th-1";